import type BaseEnumType from "@/app/services/baseEnumType";

export type FilterValue = BaseEnumType | string | number | null;

export type FilterType = {
  type: string;
  values: number;

  /**
   * Function should return true if the value is to be included (visible) otherwise false.
   * @param itemValue the raw item value can be null/object/etc.
   * @param formattedItemValue the formatted value can also be any type (depends on column type).
   * @param filterValue The value from the fitler state - will be string and not empty
   */
  applyFunc: (
    itemValue: any,
    formattedItemValue: any,
    filterValue: any
  ) => boolean;
};

export type FilterState = {
  filter1: {
    type: string;
    value: FilterValue;
  };
  filter2?: {
    type: string;
    value: FilterValue;
    operator: "and" | "or";
  };
};

export type FilterFunc = (itemValue: any, formattedItemValue: any) => boolean;

function buildSingleApply(
  filterTypes: FilterType[],
  filterType: string,
  filterValue: FilterValue
): FilterFunc {
  let filter = filterTypes.find((ft) => ft.type === filterType);
  if (filter === undefined) {
    return () => true;
  } else {
    return (itemValue: any, formattedItemValue: any) =>
      filter?.applyFunc(itemValue, formattedItemValue, filterValue) ?? false;
  }
}

/** Builds a function to evaluate the filter given a filter value and filter state **/
export function buildApplyFilter(
  state: FilterState,
  filterTypes: FilterType[]
): FilterFunc {
  if (state?.filter1?.type && state.filter1.value !== "") {
    const applyFilter1 = buildSingleApply(
      filterTypes,
      state.filter1.type,
      state.filter1.value
    );
    if (
      state?.filter2?.type &&
      state?.filter2?.value &&
      state?.filter2?.operator
    ) {
      const applyFilter2 = buildSingleApply(
        filterTypes,
        state.filter2.type,
        state.filter2.value
      );
      if (state.filter2.operator === "and") {
        return (itemValue: any, formattedItemValue: any) =>
          applyFilter1(itemValue, formattedItemValue) &&
          applyFilter2(itemValue, formattedItemValue);
      }

      // or
      return (itemValue: any, formattedItemValue: any) =>
        applyFilter1(itemValue, formattedItemValue) ||
        applyFilter2(itemValue, formattedItemValue);
    } else {
      return applyFilter1;
    }
  } else {
    return () => true;
  }
}
